/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as VodDefs from "./defs.defs.js";

const $nsid = "place.stream.vod.getComments";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"video":/*#__PURE__*/ l.string({"format":"at-uri"}),"cursor":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"limit":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.integer({"minimum":1,"maximum":100}), 50))});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"cursor":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"comments":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<VodDefs.CommentView>((() => VodDefs.commentView) as any), )});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Get comments for a place.stream.video record. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output);

export { main };

export const $lxm = $nsid;
